import {DownloadSpeedMeter} from '../../../core/DownloadSpeedMeter';
import {isNotNullish, isNullish} from '../../../utils/Utils';
import {HlsjsPlayerProxy} from '../HlsjsPlayerProxy';

import type {FragLoadedData} from './HlsJsPlayerTypes';
import {HLS_PLAYER_EVENT} from './HlsJsPlayerTypes';

export class HlsSpeedMeterAdapter {
  private meter: DownloadSpeedMeter;

  constructor(hls: HlsjsPlayerProxy, meter: DownloadSpeedMeter) {
    this.meter = meter;
    hls.on(HLS_PLAYER_EVENT.FRAG_LOADED, (_eventName, data) => this.handleFragmentLoadedEvent(data));
  }

  getDownloadSpeedMeter(): DownloadSpeedMeter {
    return this.meter;
  }

  handleFragmentLoadedEvent(eventData: FragLoadedData) {
    if (eventData.frag.type !== 'main') {
      // ignore non-video fragments
      return;
    }

    const httpStatus = isNotNullish(eventData.networkDetails)
      ? (eventData.networkDetails as {status: number}).status
      : undefined;
    if (isNullish(httpStatus)) {
      // ignore fragments that https status is undefined (networkDetails are null)
      return;
    }

    const stats = eventData.frag.stats;
    const loadingDuration = (stats.loading.end - stats.loading.start) / 1000;
    const timeToFirstByte = (stats.loading.first - stats.loading.start) / 1000;

    const measurement = {
      duration: loadingDuration,
      size: stats.total,
      timeToFirstByte: timeToFirstByte,
      timestamp: new Date(),
      httpStatus,
    };

    this.meter.addMeasurement(measurement);
  }
}
